// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__2FpaR","content":"styles_content__2BKVl","body":"styles_body__2GBfl"};